import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { auth } from '../../../firebase';
import { fetchUserProfile } from '../../../Redux/Auth/authSlice';

export default function AuthBootstrap() {
  const { user, bootstrapped } = useSelector(s => s.auth);
  const dispatch = useDispatch();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current || bootstrapped || user) return;
    ran.current = true;

    const unsub = auth.onAuthStateChanged(async (fbUser) => {
      if (!fbUser) return;
      const token = await fbUser.getIdToken(false);
      if (token) dispatch(fetchUserProfile(token));
    });

    return () => unsub();
  }, [dispatch, bootstrapped, user]);

  return null;
}
